<div class="page-wrapper">
  <div class="page-container">
    @if (isLoading) {
      <app-text size="l" weight="m" color="gray-900">
        資料載入中......
      </app-text>
    } @else {
      <!-- 左側導航 -->
      <div class="page-header">
        <div class="page-header-title">
          <app-text size="specialL" weight="m" color="gray-900">我的健康檔案</app-text>
        </div>
      </div>
    
      <!-- 右側內容區 -->
      <div class="content-area">
        <!-- 個人資料卡片 -->
        <div class="profile-card">
          <div class="profile-info">
            <app-text size="extra" weight="xl" color="primary-600">{{ userName }}</app-text>
            <div class="profile-details">
              <app-tag size="healthProfile" color="filled-green">
                <app-text size="s" weight="m" color="primary-700">{{ userGender }}</app-text>
              </app-tag>
              <app-tag size="healthProfile" color="filled-green">
                <app-text size="s" weight="m" color="primary-700">{{ userBirthday | date: 'yyyy/MM/dd' }}</app-text>
              </app-tag>
            </div>
          </div>
        
          <button mat-button class="btn-text-primary" (click)="modifyProfile()">
            <div>
              <img width="20" height="20" src="assets/img/Edit.png" alt="" />
              修改個人資料
            </div>
          </button>
        </div>

          <!-- 報告Tab -->
          <div class="report-container">
            <mat-tab-group [(selectedIndex)]="selectedTab" class="report-tabs">
              <mat-tab label="最新報告"></mat-tab>
              <mat-tab label="下載歷次報告"></mat-tab>
            </mat-tab-group>

            <app-my-reports [selectedTab]="selectedTab"></app-my-reports>
          </div>
      </div>
    }
  </div>
</div>
